import ApplicationFeatures from 'gw-portals-featuredetection-js/ApplicationFeatures';

import ViewModel from 'gw-portals-viewmodel-js';
import 'gw-portals-metadata-angular/InsuranceSuiteMetadataService';

export default ['InsuranceSuiteMetadata', function (InsuranceSuiteMetaDataService) {
    // return the service instance
    var VM = ViewModel.get(InsuranceSuiteMetaDataService);

    var config = ApplicationFeatures.getAllFeatures().viewmodel;
    if (config) {
        VM.configure(config);
    }

    return VM;
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/api/gw-portals-viewmodel-angular/ViewModelService.js
// module id = 932
// module chunks = 0